import { API_CONFIG } from "../../../config/api.config";

const getQuizBaseUrl = () => API_CONFIG.QUIZ_URL || "";

const joinUrl = (baseUrl, path) => {
  const cleanBase = baseUrl.replace(/\/+$/, "");
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${cleanBase}${cleanPath}`;
};

const buildHeaders = (headers = {}, { json = true } = {}) => {
  if (!json) return { ...headers };
  return {
    "Content-Type": "application/json",
    ...headers,
  };
};

const parseError = async (response) => {
  try {
    const data = await response.json();
    if (data?.message) return data.message;
    if (data?.error) return data.error;
    return JSON.stringify(data);
  } catch (err) {
    const text = await response.text();
    return text || `Error ${response.status}`;
  }
};

export const requestJson = async (path, { method = "GET", body, headers } = {}) => {
  const baseUrl = getQuizBaseUrl();
  if (!baseUrl) {
    throw new Error("REACT_APP_QUIZ_API_URL no esta configurado");
  }

  const response = await fetch(joinUrl(baseUrl, path), {
    method,
    headers: buildHeaders(headers, { json: true }),
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    const message = await parseError(response);
    throw new Error(message || `Error ${response.status}`);
  }

  return response.json();
};

export const requestForm = async (path, { method = "POST", body, headers } = {}) => {
  const baseUrl = getQuizBaseUrl();
  if (!baseUrl) {
    throw new Error("REACT_APP_QUIZ_API_URL no esta configurado");
  }

  const response = await fetch(joinUrl(baseUrl, path), {
    method,
    headers: buildHeaders(headers, { json: false }),
    body,
  });

  if (!response.ok) {
    const message = await parseError(response);
    throw new Error(message || `Error ${response.status}`);
  }

  return response.json();
};
